document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-mobile-nav]');

if (menuButton && menu) {
  menuButton.addEventListener('click', () => {
    const open = menu.getAttribute('data-open') !== 'true';
    menu.setAttribute('data-open', String(open));
    menuButton.setAttribute('aria-expanded', String(open));
  });
}

document.querySelectorAll('[data-product-form]').forEach((form) => {
  form.addEventListener('submit', () => {
    const button = form.querySelector('[type="submit"]');
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
  });
});
